import type { Bar } from "@chartandgo/shared";

export interface RangeChange {
  change: number;
  changePercent: number;
}

/** Calculate performance from the first tradable price in the selected range. */
export function calculateRangeChange(
  bars: Bar[],
  latestPrice?: number | null,
): RangeChange | null {
  const first = bars.find(
    (bar) => Number.isFinite(bar.open) && bar.open > 0,
  );
  const fallbackPrice = bars.at(-1)?.close;
  const current =
    latestPrice != null && Number.isFinite(latestPrice)
      ? latestPrice
      : fallbackPrice;

  if (!first || current == null || !Number.isFinite(current)) return null;

  const change = current - first.open;
  return {
    change,
    changePercent: (change / first.open) * 100,
  };
}
